<div fxFill fxLayout="column">
  <h2 *ngIf="chart.title">{{ chart.title }}</h2>
  <mat-card appearance="outlined" fxFlex fxLayout="column" fxLayoutAlign="center center">
    <mat-card-content>
      <pr-chart fxFlex [chartBuilder]="chart.chartBuilder" />
      <div [innerHTML]="chart.summary"></div>
    </mat-card-content>
  </mat-card>
</div>
